import { connect } from "react-redux";
import { ThunkDispatch } from "@reduxjs/toolkit";

import { ApplicationState } from "../../../redux/ApplicationState";
import { getMasterServiceProvider } from "../../../actions/Master";
import { getListResult } from "../../../utils";
import { postAccessAdminList, putAgencyAccessList } from "../../../actions/AdminActions";
import { AdminAccessListPayload, UpdateAgencyAccessPayload, UserPageTrack } from "../../../models/User";
import { resetStates } from "../../../actions/Common";
import AgencyAccess from "../components/AgencyAccess";
import { postUserPageTrack } from "../../../actions/UserAction";

const mapStateToProps = ({
  loggedInUserState,
  masterServiceProviderState,
  userListState,
  adminAccessListState,
  updateAgencyAccessState
}: ApplicationState) => ({
  loggedInUser: loggedInUserState.response,
  masterServiceProviderState: masterServiceProviderState.response,
  masterServiceProviderLength: getListResult(
    masterServiceProviderState.response
  ).length,
  userListState: userListState.response,
  userListLoading: userListState.loading,
  adminAccessListState: adminAccessListState.response,
  updateAgencyAccessState: updateAgencyAccessState.response,
});

const mapDispatchToProps = (
  dispatch: ThunkDispatch<ApplicationState, Record<string, never>, any>
) => {
  return {
    getMasterServiceProvider: () => {
      dispatch(getMasterServiceProvider());
    },
    postAccessAdminList: (payload: AdminAccessListPayload) => {
      dispatch(postAccessAdminList(payload));
    },
    updateAgencyAccess: (payload: UpdateAgencyAccessPayload) => {
      dispatch(putAgencyAccessList(payload));
    },
    resetStates: (actionType: string) => {
      dispatch(resetStates(actionType));
    },
    postUserPageTrack: (payload: UserPageTrack) => {
      dispatch(postUserPageTrack(payload));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AgencyAccess);
